import commonJsModule from "log-watcher-webpack-plugin"

export default commonJsModule.default